module.exports = __webpack_public_path__ + "img/einvoice-received-filter.c5d3c638.svg";